/*
  Übersetzt die festen deutschen Beschriftungen der Klaviyo-Review-Widgets in die Shop-Sprache.
  - Texte kommen aus den Theme-Übersetzungen (klaviyo_reviews.*), siehe layout/theme.liquid
  - Relative Zeitangaben ("vor 15 Tagen") übersetzt der Browser per Intl.RelativeTimeFormat
  - Bewertungstexte der Kunden bleiben unverändert
*/
(function () {
  var config = window.klReviewsI18n;
  if (!config || !config.t) return;

  var t = config.t;
  var lang = config.lang;

  // Sprache ohne eigene Übersetzung (fällt auf Deutsch zurück, z.B. nl vor Translate & Adapt): nichts tun, sonst entsteht ein Sprachmix
  if (t.verified_buyer === 'Verifizierte*r Käufer*in') return;

  // Feste Klaviyo-Texte (deutsch) -> Übersetzungs-Key
  var exact = {
    'Verifizierte*r Käufer*in': t.verified_buyer,
    'Neueste zuerst': t.sort_newest,
    'Am besten bewertet': t.sort_highest,
    'Am schlechtesten bewertet': t.sort_lowest,
    'Am relevantesten': t.sort_relevant,
    'Alle Bewertungen': t.filter_all,
    'Mit Medien': t.with_media,
    'Mehr anzeigen': t.show_more,
    'Bewertungen': t.tab_reviews,
    'Fragen': t.tab_questions,
    'Bewertung schreiben': t.write_review,
    'Frage stellen': t.ask_question,
    'Suchen': t.search,
    'Bewertungen durchsuchen': t.search_placeholder,
    'Sortieren nach:': t.sort_by,
    'Filtern nach:': t.filter_by,
    'Slideshow-Schaltfläche „Zurück“': t.slideshow_prev,
    'Slideshow-Schaltfläche „Weiter“': t.slideshow_next
  };

  var units = {
    Sekunde: 'second', Sekunden: 'second',
    Minute: 'minute', Minuten: 'minute',
    Stunde: 'hour', Stunden: 'hour',
    Tag: 'day', Tagen: 'day',
    Woche: 'week', Wochen: 'week',
    Monat: 'month', Monaten: 'month',
    Jahr: 'year', Jahren: 'year'
  };

  var rtf = null;
  try {
    rtf = new Intl.RelativeTimeFormat(lang, { numeric: 'always' });
  } catch (error) {}

  function relative(amount, unit) {
    return rtf ? rtf.format(-amount, units[unit]) : null;
  }

  function withCount(template, count) {
    return template ? template.replace('[count]', count) : null;
  }

  var patterns = [
    // "Gekauft am vor 14 Tagen"
    [/^Gekauft am vor (\d+) (\S+)$/, function (m) {
      var time = units[m[2]] && relative(+m[1], m[2]);
      return time && t.purchased ? t.purchased + ' ' + time : null;
    }],
    // "vor 15 Tagen"
    [/^vor (\d+) (\S+)$/, function (m) {
      return units[m[2]] ? relative(+m[1], m[2]) : null;
    }],
    // "1 Stern" / "3 Sterne"
    [/^1 Stern$/, function () { return t.star_one; }],
    [/^(\d+) Sterne$/, function (m) { return withCount(t.star_other, m[1]); }],
    // "1 Bewertung" / "781 Bewertungen"
    [/^1 Bewertung$/, function () { return t.review_one; }],
    [/^([\d.]+) Bewertungen$/, function (m) { return withCount(t.review_other, m[1]); }],
    // "5-Sterne-Bewertung"
    [/^(\d+)-Sterne-Bewertung$/, function (m) { return withCount(t.star_rating, m[1]); }],
    // "Die durchschnittliche Bewertung liegt bei 4,8 Sternen"
    [/^Die durchschnittliche Bewertung liegt bei ([\d,.]+) Sternen$/, function (m) {
      return t.average_rating ? t.average_rating.replace('[rating]', m[1]) : null;
    }]
  ];

  function translate(text) {
    // Klaviyo nutzt teils geschützte Leerzeichen (z.B. "1\u00a0Bewertung")
    var trimmed = text.replace(/\u00a0/g, ' ').trim();
    if (!trimmed) return null;
    if (Object.prototype.hasOwnProperty.call(exact, trimmed)) return exact[trimmed] || null;
    for (var i = 0; i < patterns.length; i++) {
      var match = trimmed.match(patterns[i][0]);
      if (match) return patterns[i][1](match);
    }
    return null;
  }

  function translateTextNode(node) {
    var value = node.nodeValue;
    var result = translate(value);
    if (result && result !== value.trim()) {
      // Leerzeichen um den Text herum beibehalten
      var leading = value.match(/^\s*/)[0];
      var trailing = value.match(/\s*$/)[0];
      node.nodeValue = leading + result + trailing;
    }
  }

  var ATTRIBUTES = ['placeholder', 'aria-label', 'title'];

  function translateElement(element) {
    ATTRIBUTES.forEach(function (name) {
      var value = element.getAttribute(name);
      if (!value) return;
      var result = translate(value);
      if (result && result !== value) element.setAttribute(name, result);
    });
  }

  function isInsideWidget(node) {
    var element = node.nodeType === 1 ? node : node.parentElement;
    return !!(element && element.closest('[id*="klaviyo_reviews"], [id^="klaviyo-"][id*="review"], [class*="kl_reviews"]'));
  }

  function walk(root) {
    if (root.nodeType === 3) {
      if (isInsideWidget(root)) translateTextNode(root);
      return;
    }
    if (root.nodeType !== 1 || !isInsideWidget(root)) {
      // Widget kann tiefer im eingefügten Teilbaum liegen
      if (root.querySelectorAll) {
        root.querySelectorAll('[id*="klaviyo_reviews"], [id^="klaviyo-"][id*="review"], [class*="kl_reviews"]').forEach(walk);
      }
      return;
    }
    translateElement(root);
    root.querySelectorAll('[placeholder], [aria-label], [title]').forEach(translateElement);
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) translateTextNode(node);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'characterData') {
        if (isInsideWidget(mutation.target)) translateTextNode(mutation.target);
      } else if (mutation.type === 'attributes') {
        if (isInsideWidget(mutation.target)) translateElement(mutation.target);
      } else {
        mutation.addedNodes.forEach(walk);
      }
    });
  });

  function start() {
    walk(document.body);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ATTRIBUTES
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
